import { axiosClient } from '@/plugins/axios'
import { AxiosResponse } from 'axios'
import { convertHyphenDelimiter } from '@/commons/utils/dateUtil'
import { DownloadResponse } from '@/commons/interfaces/responses/download'
import qs from 'qs'
import { MonthlyVisitRateResponse } from '../types'

/**
 * 月別比率の取得
 * @param {string[]} chainIds 対象のチェーンIDs
 * @param {string[]} prefectureIds 対象の都道府県IDs
 * @param {string} start 期間開始日(yyyy-MM-dd)
 * @param {string} end 期間終了日(yyyy-MM-dd)
 * @param {AbortSignal} signal APIの中断用オブジェクト
 * @returns
 */
export function getMonthlyVisitRate(
  chainIds: string[],
  prefectureIds: string[],
  start: string,
  end: string,
  signal?: AbortSignal
): Promise<AxiosResponse<MonthlyVisitRateResponse>> {
  return axiosClient.get<MonthlyVisitRateResponse>(
    '/chains/chart/monthly-visit-rate/chain-comparison/',
    {
      params: {
        chainIds,
        prefectureIds,
        start: convertHyphenDelimiter(start),
        end: convertHyphenDelimiter(end)
      },
      paramsSerializer: (params) => {
        return qs.stringify(params, { arrayFormat: 'repeat' })
      },
      signal: signal
    }
  )
}

/**
 * 来店人数チェーン比較DL
 * @param {string[]} chainIds 対象のチェーンIDs
 * @param {string[]} prefectureIds 対象の都道府県IDs
 * @param {number} particle 表示粒度。日別、週別、月別、時間帯別、曜日別の5種。
 * @param {string} start 期間開始日(yyyy-MM-dd)
 * @param {string} end 期間終了日(yyyy-MM-dd)
 * @returns
 */
export function downloadVisitCountChartCSV(
  chainIds: string[],
  prefectureIds: string[],
  particle: number,
  start: string,
  end: string
): Promise<AxiosResponse<DownloadResponse>> {
  return axiosClient.get<DownloadResponse>(
    '/chains/chart/visit-count-chart/chain-comparison/download/',
    {
      params: {
        chainIds,
        prefectureIds,
        particle: particle,
        start: convertHyphenDelimiter(start),
        end: convertHyphenDelimiter(end)
      },
      paramsSerializer: (params) => {
        return qs.stringify(params, { arrayFormat: 'repeat' })
      }
    }
  )
}

/**
 * 月別比率DL
 * @param {string[]} chainIds 対象のチェーンIDs
 * @param {string[]} prefectureIds 対象の都道府県IDs
 * @param {string} start 期間開始日(yyyy-MM-dd)
 * @param {string} end 期間終了日(yyyy-MM-dd)
 * @returns
 */
export function downloadMonthlyVisitRateCSV(
  chainIds: string[],
  prefectureIds: string[],
  start: string,
  end: string
): Promise<AxiosResponse<DownloadResponse>> {
  return axiosClient.get<DownloadResponse>(
    '/chains/chart/monthly-visit-rate/chain-comparison/download/',
    {
      params: {
        chainIds,
        prefectureIds,
        start: convertHyphenDelimiter(start),
        end: convertHyphenDelimiter(end)
      },
      paramsSerializer: (params) => {
        return qs.stringify(params, { arrayFormat: 'repeat' })
      }
    }
  )
}
